import { combineReducers } from 'redux'

import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'

import analyticReducer from '@reducers/analytic'
import authReducer from '@reducers/auth'
import safeWalkReducer from '@reducers/safewalk'
import chatReducer from '@reducers/chat'
import configReducer from '@reducers/config'
import engageReducer from '@reducers/engage'
import errorReducer from '@reducers/error'
import initializeReducer from '@reducers/initialize'
import locationReducer from '@reducers/location'
import messageReducer from '@reducers/message'
import navReducer from '@reducers/nav'
import sheetReducer from '@reducers/sheet'
import routesReducer from '@reducers/routes'
import searchlightReducer from '@reducers/searchlight'
import tipReducer from '@reducers/tip'
import uiReducer from '@reducers/ui'

const rootReducer = combineReducers({
  analytic: analyticReducer,
  auth: authReducer,
  safewalk: safeWalkReducer,
  chat: chatReducer,
  config: configReducer,
  engage: engageReducer,
  error: errorReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  initialize: initializeReducer,
  location: locationReducer,
  message: messageReducer,
  nav: navReducer,
  sheet: sheetReducer,
  routes: routesReducer,
  searchlight: searchlightReducer,
  tip: tipReducer,
  ui: uiReducer
})

export default rootReducer
